export const SINGLE_CALLCARD_PARTICULARS = 'SingleCallcardParticulars';
export const PCE_DESCRIPTION_VALUE = 9;
